import {ApiResponseStatus} from "@biletix/core/models/api-response-status";
import {ApiError} from "@biletix/core/models/api-error";
import {ApiWarning} from "@biletix/core/models/api-warning";


export class ApiResponse<T> {

  status: ApiResponseStatus;

  data: T;

  errors?: ApiError[];

  warnings?: ApiWarning[];

  constructor(init: {
    status: ApiResponseStatus,
    data: T,
    errors?: ApiError[],
    warnings?: ApiWarning[],
  }) {
    this.status = init.status;
    this.data = init.data;
    this.errors = init.errors;
    this.warnings = init.warnings;
  }


}
